import { Day } from "../types";

export const MINUTES = 60;
export const HOURS = 60 * MINUTES;
export const DAYS = 24 * HOURS;
export const WEEKS = 7 * DAYS;

export const DAYS_OF_THE_WEEK: Day[] = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const Species = {
  Aedeomyia: {
    africana: "africana",
    furfurea: "furfurea",
  },
  Aedes: {
    abnormalis: "abnormalis",
    aboriginis: "aboriginis",
    abserratus: "abserratus",
    adami: "adami",
    adersi: "adersi",
    aegypti: "aegypti",
    aerarius: "aerarius",
    albicosta: "albicosta",
    albineus: "albineus",
    albocephalus: "albocephalus",
    albomarginatus: "albomarginatus",
    albopictus: "albopictus",
    alboscutellatus: "alboscutellatus",
    albothorax: "albothorax",
    alboventralis: "alboventralis",
    aloponotum: "aloponotum",
    amaltheus: "amaltheus",
    angustus: "angustus",
    annulipes: "annulipes",
    apicoannulatus: "apicoannulatus",
    apicoargenteus: "apicoargenteus",
    argenteopunctatus: "argenteopunctatus",
    argenteoventralis: "argenteoventralis",
    atlanticus: "atlanticus",
    atropalpus: "atropalpus",
    aurifer: "aurifer",
    aurovenatus: "aurovenatus",
    bahamensis: "bahamensis",
    bambiotai: "bambiotai",
    bambusae: "bambusae",
    bananea: "bananea",
    bancoi: "bancoi",
    barnardi: "barnardi",
    bedfordi: "bedfordi",
    begeradi: "begeradi",
    bequaerti: "bequaerti",
    bergerardi: "bergerardi",
    berlandi: "berlandi",
    bevisi: "bevisi",
    bicristatus: "bicristatus",
    bimaculatus: "bimaculatus",
    biskraensis: "biskraensis",
    blacklocki: "blacklocki",
    bolense: "bolense",
    boneti: "boneti",
    breedensis: "breedensis",
    brelandi: "brelandi",
    bromeliae: "bromeliae",
    burgeri: "burgeri",
    caballus: "caballus",
    calceatus: "calceatus",
    caliginosus: "caliginosus",
    campestris: "campestris",
    canadensis: "canadensis",
    cantans: "cantans",
    cantator: "cantator",
    capensis: "capensis",
    carteri: "carteri",
    caspius: "caspius",
    cataphylla: "cataphylla",
    centropunctatus: "centropunctatus",
    chamboni: "chamboni",
    chaussieri: "chaussieri",
    chelli: "chelli",
    churchillensis: "churchillensis",
    cinereus: "cinereus",
    circumluteolus: "circumluteolus",
    clivis: "clivis",
    coluzzii: "coluzzii",
    communis: "communis",
    contiguus: "contiguus",
    cordellieri: "cordellieri",
    corneti: "corneti",
    cozi: "cozi",
    crassiforceps: "crassiforceps",
    cumminsii: "cumminsii",
    dalzieli: "dalzieli",
    deboeri: "deboeri",
    decticus: "decticus",
    demeilloni: "demeilloni",
    denderensis: "denderensis",
    dendrophilus: "dendrophilus",
    dentatus: "dentatus",
    deserticola: "deserticola",
    detritus: "detritus",
    dialloi: "dialloi",
    diantaeus: "diantaeus",
    domesticus: "domesticus",
    dorsalis: "dorsalis",
    "dorsalis nearctic": "dorsalis nearctic",
    "dorsalis palearctic": "dorsalis palearctic",
    dupreei: "dupreei",
    durbanensis: "durbanensis",
    ealaensis: "ealaensis",
    ebogoensis: "ebogoensis",
    echinus: "echinus",
    ellinorae: "ellinorae",
    embuensis: "embuensis",
    epactius: "epactius",
    eritreae: "eritreae",
    ethiopiensis: "ethiopiensis",
    euedes: "euedes",
    excrucians: "excrucians",
    falabreguesi: "falabreguesi",
    fascipalpis: "fascipalpis",
    filicis: "filicis",
    fitchii: "fitchii",
    flavescens: "flavescens",
    flavicollis: "flavicollis",
    flavimargo: "flavimargo",
    flavopictus: "flavopictus",
    fowleri: "fowleri",
    fraseri: "fraseri",
    fryeri: "fryeri",
    fulgens: "fulgens",
    fulvus: "fulvus",
    "fulvus pallens": "fulvus pallens",
    furcifer: "furcifer",
    fuscinervis: "fuscinervis",
    gandaensis: "gandaensis",
    geminus: "geminus",
    geniculatus: "geniculatus",
    geoffroyi: "geoffroyi",
    gibbinsi: "gibbinsi",
    gilliesi: "gilliesi",
    grahamii: "grahamii",
    grenieri: "grenieri",
    grjebinei: "grjebinei",
    grossbecki: "grossbecki",
    hancocki: "hancocki",
    hansfordi: "hansfordi",
    harrisoni: "harrisoni",
    haworthi: "haworthi",
    heischi: "heischi",
    hendersoni: "hendersoni",
    hexodontus: "hexodontus",
    hirsutus: "hirsutus",
    holocinctus: "holocinctus",
    hopkinsi: "hopkinsi",
    huangae: "huangae",
    impiger: "impiger",
    implicatus: "implicatus",
    "increpitus ss": "increpitus ss",
    infirmatus: "infirmatus",
    ingrami: "ingrami",
    insolens: "insolens",
    intrudens: "intrudens",
    irritans: "irritans",
    jamoti: "jamoti",
    japonicus: "japonicus",
    josiahae: "josiahae",
    juppi: "juppi",
    kapretwae: "kapretwae",
    karooensis: "karooensis",
    keniensis: "keniensis",
    kennethi: "kennethi",
    kenya: "kenya",
    kivuensis: "kivuensis",
    koreicus: "koreicus",
    kummi: "kummi",
    lamborni: "lamborni",
    langata: "langata",
    ledgeri: "ledgeri",
    leesoni: "leesoni",
    leptolabis: "leptolabis",
    leucarthrius: "leucarthrius",
    leucomelas: "leucomelas",
    lilii: "lilii",
    lineatopennis: "lineatopennis",
    lokojensis: "lokojensis",
    longipalpis: "longipalpis",
    longiseta: "longiseta",
    lottei: "lottei",
    lucianus: "lucianus",
    luridus: "luridus",
    luteocephalus: "luteocephalus",
    luteolateralis: "luteolateralis",
    luteostriatus: "luteostriatus",
    malayensis: "malayensis",
    mansoniauri: "mansoniauri",
    mariae: "mariae",
    marshallii: "marshallii",
    masseyi: "masseyi",
    mattinglyi: "mattinglyi",
    mattinglyorum: "mattinglyorum",
    maxgermaini: "maxgermaini",
    mcintoshi: "mcintoshi",
    mediovittatus: "mediovittatus",
    mefouensis: "mefouensis",
    melanimon: "melanimon",
    mercurator: "mercurator",
    metallicus: "metallicus",
    michaelikati: "michaelikati",
    mickevichae: "mickevichae",
    microstictus: "microstictus",
    minutus: "minutus",
    mitchellae: "mitchellae",
    mixtus: "mixtus",
    monotrichus: "monotrichus",
    monticola: "monticola",
    mpusiensis: "mpusiensis",
    mucidus: "mucidus",
    muelleri: "muelleri",
    muroafcete: "muroafcete",
    mutilus: "mutilus",
    mzooi: "mzooi",
    natalensis: "natalensis",
    natronius: "natronius",
    neoafricanus: "neoafricanus",
    nevadensis: "nevadensis",
    ngong: "ngong",
    nigerrimus: "nigerrimus",
    nigricephalus: "nigricephalus",
    nigromaculis: "nigromaculis",
    niphadopsis: "niphadopsis",
    njombiensis: "njombiensis",
    notoscriptus: "notoscriptus",
    nyasae: "nyasae",
    nyounae: "nyounae",
    ochraceus: "ochraceus",
    okinawanus: "okinawanus",
    opok: "opok",
    ovazzai: "ovazzai",
    pachyurus: "pachyurus",
    palpalis: "palpalis",
    papago: "papago",
    pembaensis: "pembaensis",
    phyllolabis: "phyllolabis",
    pionips: "pionips",
    pogonurus: "pogonurus",
    pollinctor: "pollinctor",
    polynesiensis: "polynesiensis",
    poweri: "poweri",
    provocans: "provocans",
    pseudoafricanus: "pseudoafricanus",
    pseudonigeria: "pseudonigeria",
    pseudotarsalis: "pseudotarsalis",
    pubescens: "pubescens",
    pulchrithorax: "pulchrithorax",
    pulcritarsis: "pulcritarsis",
    pullatus: "pullatus",
    punctocostalis: "punctocostalis",
    punctor: "punctor",
    punctothoracis: "punctothoracis",
    purpureipes: "purpureipes",
    quasirusticus: "quasirusticus",
    quasiunivittatus: "quasiunivittatus",
    reali: "reali",
    rickenbachi: "rickenbachi",
    riparius: "riparius",
    rusticus: "rusticus",
    ruwenzori: "ruwenzori",
    saimedres: "saimedres",
    sampi: "sampi",
    scapularis: "scapularis",
    scatophagoides: "scatophagoides",
    schizopinax: "schizopinax",
    schwetzi: "schwetzi",
    "scutellaris ss": "scutellaris ss",
    seampi: "seampi",
    semlikiensis: "semlikiensis",
    sierrensis: "sierrensis",
    simpsoni: "simpsoni",
    simulans: "simulans",
    smithburni: "smithburni",
    soleatus: "soleatus",
    sollicitans: "sollicitans",
    spencerii: "spencerii",
    "spencerii idahoensis": "spencerii idahoensis",
    "spencerii spencerii": "spencerii spencerii",
    squamiger: "squamiger",
    stenoscutus: "stenoscutus",
    sticticus: "sticticus",
    stimulans: "stimulans",
    stokesi: "stokesi",
    strelitziae: "strelitziae",
    subargenteus: "subargenteus",
    subdentatus: "subdentatus",
    sudanensis: "sudanensis",
    taeniarostris: "taeniarostris",
    taeniorhynchus: "taeniorhynchus",
    tahoensis: "tahoensis",
    tauffliebi: "tauffliebi",
    taylori: "taylori",
    teesdalei: "teesdalei",
    thelcter: "thelcter",
    thibaulti: "thibaulti",
    togoi: "togoi",
    tormentor: "tormentor",
    tortilis: "tortilis",
    tricholabis: "tricholabis",
    triseriatus: "triseriatus",
    trivittatus: "trivittatus",
    unidentatus: "unidentatus",
    unilineatus: "unilineatus",
    usambara: "usambara",
    varipalpus: "varipalpus",
    veeniae: "veeniae",
    ventrovittis: "ventrovittis",
    vexans: "vexans",
    washinoi: "washinoi",
    wellmanii: "wellmanii",
    wendyae: "wendyae",
    wigglesworthi: "wigglesworthi",
    woodi: "woodi",
    yangambiensis: "yangambiensis",
    yvonneae: "yvonneae",
    zethus: "zethus",
    zoosophus: "zoosophus",
  },
  Anopheles: {
    ainshamsi: "ainshamsi",
    albimanus: "albimanus",
    algeriensis: "algeriensis",
    amharicus: "amharicus",
    arabiensis: "arabiensis",
    ardensis: "ardensis",
    argenteolobatus: "argenteolobatus",
    aruni: "aruni",
    atroparvus: "atroparvus",
    atropos: "atropos",
    austeni: "austeni",
    austenii: "austenii",
    azaniae: "azaniae",
    azevedoi: "azevedoi",
    bancroftii: "bancroftii",
    barberellus: "barberellus",
    barberi: "barberi",
    beklemishevi: "beklemishevi",
    berghei: "berghei",
    bervoetsi: "bervoetsi",
    bradleyi: "bradleyi",
    brohieri: "brohieri",
    brucei: "brucei",
    brumpti: "brumpti",
    brunnipes: "brunnipes",
    buxtoni: "buxtoni",
    bwambae: "bwambae",
    caliginosus: "caliginosus",
    cameroni: "cameroni",
    carnevalei: "carnevalei",
    caroni: "caroni",
    carteri: "carteri",
    cavernicolus: "cavernicolus",
    christyi: "christyi",
    cinctus: "cinctus",
    cinereus: "cinereus",
    claviger: "claviger",
    coluzzii: "coluzzii",
    comorensis: "comorensis",
    concolor: "concolor",
    confusus: "confusus",
    "coustani ss": "coustani ss",
    cristipalpis: "cristipalpis",
    "crucians ss": "crucians ss",
    crypticus: "crypticus",
    culicifacies: "culicifacies",
    cydippis: "cydippis",
    daciae: "daciae",
    dancalicus: "dancalicus",
    daudi: "daudi",
    deemingi: "deemingi",
    demeilloni: "demeilloni",
    diluvialis: "diluvialis",
    "dirus s.l.": "dirus s.l.",
    "dirus s.s.": "dirus s.s.",
    "dirus ss": "dirus ss",
    distinctus: "distinctus",
    domicolus: "domicolus",
    dthali: "dthali",
    dualaensis: "dualaensis",
    dureni: "dureni",
    earlei: "earlei",
    eouzani: "eouzani",
    erepens: "erepens",
    erythraeus: "erythraeus",
    ethiopicus: "ethiopicus",
    faini: "faini",
    "farauti s.l.": "farauti s.l.",
    "farauti ss": "farauti ss",
    flavicosta: "flavicosta",
    fontenillei: "fontenillei",
    fontinalis: "fontinalis",
    franciscanus: "franciscanus",
    "freeborni ss": "freeborni ss",
    freetownensis: "freetownensis",
    funestus: "funestus",
    "funestus-like": "funestus-like",
    fuscicolor: "fuscicolor",
    fuscivenosus: "fuscivenosus",
    gabonensis: "gabonensis",
    "gambiae ss": "gambiae ss",
    garnhami: "garnhami",
    georgianus: "georgianus",
    gibbinsi: "gibbinsi",
    grassei: "grassei",
    grenieri: "grenieri",
    griveaudi: "griveaudi",
    hamoni: "hamoni",
    hancocki: "hancocki",
    hargreavesi: "hargreavesi",
    harperi: "harperi",
    hermsi: "hermsi",
    hervyi: "hervyi",
    hughi: "hughi",
    hyrcanus: "hyrcanus",
    implexus: "implexus",
    inundatus: "inundatus",
    jebudensis: "jebudensis",
    judithae: "judithae",
    keniensis: "keniensis",
    kingi: "kingi",
    koliensis: "koliensis",
    kosiensis: "kosiensis",
    labranchiae: "labranchiae",
    lacani: "lacani",
    leesoni: "leesoni",
    letabensis: "letabensis",
    listeri: "listeri",
    lloreti: "lloreti",
    longipalpis: "longipalpis",
    longirostris: "longirostris",
    lounibosi: "lounibosi",
    lovettae: "lovettae",
    machardyi: "machardyi",
    maculipalpis: "maculipalpis",
    maculipennis: "maculipennis",
    maliensis: "maliensis",
    marshalli: "marshalli",
    marshallii: "marshallii",
    marteri: "marteri",
    mascarensis: "mascarensis",
    maverlius: "maverlius",
    melanoon: "melanoon",
    melas: "melas",
    merus: "merus",
    messeae: "messeae",
    millecampsi: "millecampsi",
    milloti: "milloti",
    minimus: "minimus",
    mortiauxi: "mortiauxi",
    moucheti: "moucheti",
    "moucheti nigeriensis": "moucheti nigeriensis",
    "moucheti s.l": "moucheti s.l",
    "moucheti s.s": "moucheti s.s",
    mousinhoi: "mousinhoi",
    multicinctus: "multicinctus",
    multicolor: "multicolor",
    murphyi: "murphyi",
    namibiensis: "namibiensis",
    natalensis: "natalensis",
    nigeriensis: "nigeriensis",
    nili: "nili",
    "nili s.s": "nili s.s",
    "nili ss": "nili ss",
    njombiensis: "njombiensis",
    notleyi: "notleyi",
    obscurus: "obscurus",
    occidentalis: "occidentalis",
    okuensis: "okuensis",
    ovengensis: "ovengensis",
    paludis: "paludis",
    parensis: "parensis",
    pauliani: "pauliani",
    perplexens: "perplexens",
    petragnani: "petragnani",
    pharoensis: "pharoensis",
    plumbeus: "plumbeus",
    pretoriensis: "pretoriensis",
    pseudopunctipennis: "pseudopunctipennis",
    punctipennis: "punctipennis",
    punctulatus: "punctulatus",
    quadriannulatus: "quadriannulatus",
    "quadrimaculatus ss": "quadrimaculatus ss",
    rabaiensis: "rabaiensis",
    radama: "radama",
    rageaui: "rageaui",
    ranci: "ranci",
    rhodesiensis: "rhodesiensis",
    "rhodesiensis rupicolus": "rhodesiensis rupicolus",
    rivulorum: "rivulorum",
    "rivulorum-like": "rivulorum-like",
    rodhaini: "rodhaini",
    roubaudi: "roubaudi",
    ruarinus: "ruarinus",
    rufipes: "rufipes",
    sacharovi: "sacharovi",
    salbaii: "salbaii",
    schwetzi: "schwetzi",
    seretsei: "seretsei",
    sergentii: "sergentii",
    "sergentii macmahoni": "sergentii macmahoni",
    seydeli: "seydeli",
    sinensis: "sinensis",
    smaragdinus: "smaragdinus",
    smithii: "smithii",
    somalicus: "somalicus",
    squamosus: "squamosus",
    squamous: "squamous",
    stephensi: "stephensi",
    superpictus: "superpictus",
    swahilicus: "swahilicus",
    symesi: "symesi",
    tchekedii: "tchekedii",
    tenebrosus: "tenebrosus",
    theileri: "theileri",
    turkhudi: "turkhudi",
    ugandae: "ugandae",
    vaneedeni: "vaneedeni",
    vanhoofi: "vanhoofi",
    vernus: "vernus",
    vinckei: "vinckei",
    walkeri: "walkeri",
    walravensi: "walravensi",
    watsoni: "watsoni",
    wellcomei: "wellcomei",
    "wellcomei erepens": "wellcomei erepens",
    wilsoni: "wilsoni",
    ziemanni: "ziemanni",
  },
  Armigeres: {
    subalbatus: "subalbatus",
  },
  Coquillettidia: {
    annettii: "annettii",
    aurea: "aurea",
    aurites: "aurites",
    buxtoni: "buxtoni",
    chrysosoma: "chrysosoma",
    crassipes: "crassipes",
    cristata: "cristata",
    flavocincta: "flavocincta",
    fraseri: "fraseri",
    fuscopennata: "fuscopennata",
    grandidieri: "grandidieri",
    karandalaensis: "karandalaensis",
    maculipennis: "maculipennis",
    metallica: "metallica",
    microannulata: "microannulata",
    nigritarsis: "nigritarsis",
    nigrithorax: "nigrithorax",
    ochracea: "ochracea",
    perturbans: "perturbans",
    pseudoconopas: "pseudoconopas",
    richiardii: "richiardii",
    schoutedeni: "schoutedeni",
    vanoyei: "vanoyei",
    versicolor: "versicolor",
    voltaensis: "voltaensis",
    wahlbergi: "wahlbergi",
  },
  Culex: {
    abominator: "abominator",
    acrostichalis: "acrostichalis",
    adairi: "adairi",
    adami: "adami",
    adersianus: "adersianus",
    akritos: "akritos",
    albertianus: "albertianus",
    albiventris: "albiventris",
    amaniensis: "amaniensis",
    andersoni: "andersoni",
    andreanus: "andreanus",
    anips: "anips",
    annulioris: "annulioris",
    antennatus: "antennatus",
    apicalis: "apicalis",
    arbieeni: "arbieeni",
    argenteopunctatus: "argenteopunctatus",
    arizonensis: "arizonensis",
    astridianus: "astridianus",
    atratus: "atratus",
    aurantapex: "aurantapex",
    avianus: "avianus",
    bahamensis: "bahamensis",
    beta: "beta",
    biscaynensis: "biscaynensis",
    bitaeniorhynchus: "bitaeniorhynchus",
    boharti: "boharti",
    brumpti: "brumpti",
    bukavuensis: "bukavuensis",
    calabarensis: "calabarensis",
    calurus: "calurus",
    cambournaci: "cambournaci",
    castelli: "castelli",
    castor: "castor",
    cedecei: "cedecei",
    chidesteri: "chidesteri",
    chorleyi: "chorleyi",
    cinerellus: "cinerellus",
    cinereus: "cinereus",
    coronator: "coronator",
    decens: "decens",
    declarator: "declarator",
    deserticola: "deserticola",
    duttoni: "duttoni",
    eouzani: "eouzani",
    erraticus: "erraticus",
    erythrothorax: "erythrothorax",
    europaeus: "europaeus",
    fimbriforceps: "fimbriforceps",
    furlongi: "furlongi",
    fuscocephala: "fuscocephala",
    galliardi: "galliardi",
    gamma: "gamma",
    garioui: "garioui",
    gelidus: "gelidus",
    germaini: "germaini",
    gilliesi: "gilliesi",
    grahamii: "grahamii",
    grenieri: "grenieri",
    guiarti: "guiarti",
    hamoni: "hamoni",
    hancocki: "hancocki",
    harleyi: "harleyi",
    helenae: "helenae",
    hopkinsi: "hopkinsi",
    horridus: "horridus",
    hortensis: "hortensis",
    ikelos: "ikelos",
    impudicus: "impudicus",
    inatomii: "inatomii",
    inconspicuosus: "inconspicuosus",
    ingrami: "ingrami",
    insignis: "insignis",
    interrogator: "interrogator",
    invidiosus: "invidiosus",
    iolambdis: "iolambdis",
    kanyamwerima: "kanyamwerima",
    kilara: "kilara",
    kingianus: "kingianus",
    laplantei: "laplantei",
    laticinctus: "laticinctus",
    liberiensis: "liberiensis",
    lineatus: "lineatus",
    litwakae: "litwakae",
    macfiei: "macfiei",
    martinii: "martinii",
    mijanae: "mijanae",
    mimeticus: "mimeticus",
    mirificus: "mirificus",
    modestus: "modestus",
    mongiro: "mongiro",
    moucheti: "moucheti",
    mulrennani: "mulrennani",
    mundulus: "mundulus",
    musarum: "musarum",
    muspratti: "muspratti",
    nakuruensis: "nakuruensis",
    neavei: "neavei",
    nebulosus: "nebulosus",
    nigripalpus: "nigripalpus",
    ninagongoensis: "ninagongoensis",
    orientalis: "orientalis",
    ornatothoracis: "ornatothoracis",
    orstom: "orstom",
    pajoti: "pajoti",
    peccator: "peccator",
    perexiguus: "perexiguus",
    perfidiosus: "perfidiosus",
    perfuscus: "perfuscus",
    peringueyi: "peringueyi",
    philipi: "philipi",
    pilosus: "pilosus",
    pipiens: "pipiens",
    "pipiens biotype molestus": "pipiens biotype molestus",
    "pipiens sl": "pipiens sl",
    "pipiens ss": "pipiens ss",
    poicilipes: "poicilipes",
    prosecutor: "prosecutor",
    pruina: "pruina",
    pseudoandreanus: "pseudoandreanus",
    pseudopruina: "pseudopruina",
    pullus: "pullus",
    pusillus: "pusillus",
    quasiguiarti: "quasiguiarti",
    quinquefasciatus: "quinquefasciatus",
    quintetti: "quintetti",
    reevesi: "reevesi",
    "restuans ss": "restuans ss",
    richeti: "richeti",
    rima: "rima",
    riojanus: "riojanus",
    rubinotus: "rubinotus",
    ryukyensis: "ryukyensis",
    salinarius: "salinarius",
    salisburiensis: "salisburiensis",
    schwetzi: "schwetzi",
    scottii: "scottii",
    seldeslachtsi: "seldeslachtsi",
    semibrunneus: "semibrunneus",
    shoae: "shoae",
    simpliciforceps: "simpliciforceps",
    simpsoni: "simpsoni",
    sinaiticus: "sinaiticus",
    sitiens: "sitiens",
    stigmatosoma: "stigmatosoma",
    striatipes: "striatipes",
    subaequalis: "subaequalis",
    subrima: "subrima",
    subsalisburiensis: "subsalisburiensis",
    sunyaniensis: "sunyaniensis",
    taeniopus: "taeniopus",
    tamsi: "tamsi",
    tarsalis: "tarsalis",
    tauffliebi: "tauffliebi",
    telesilla: "telesilla",
    tenagius: "tenagius",
    territans: "territans",
    terzii: "terzii",
    thalassius: "thalassius",
    theileri: "theileri",
    thriambus: "thriambus",
    tigripes: "tigripes",
    toroensis: "toroensis",
    torrentium: "torrentium",
    trifilatus: "trifilatus",
    trifoliatus: "trifoliatus",
    tritaeniorhynchus: "tritaeniorhynchus",
    umbripes: "umbripes",
    univittatus: "univittatus",
    vagans: "vagans",
    vansomereni: "vansomereni",
    vattieri: "vattieri",
    ventrilloni: "ventrilloni",
    verutus: "verutus",
    vinckei: "vinckei",
    vishnui: "vishnui",
    wansoni: "wansoni",
    watti: "watti",
    weschei: "weschei",
    whitmorei: "whitmorei",
    wigglesworthi: "wigglesworthi",
    yojoae: "yojoae",
    zombaensis: "zombaensis",
  },
  Culiseta: {
    alaskaensis: "alaskaensis",
    annulata: "annulata",
    bergrothi: "bergrothi",
    fraseri: "fraseri",
    fumipennis: "fumipennis",
    impatiens: "impatiens",
    incidens: "incidens",
    inornata: "inornata",
    litorea: "litorea",
    longiareolata: "longiareolata",
    melanura: "melanura",
    minnesotae: "minnesotae",
    morsitans: "morsitans",
    nipponica: "nipponica",
    ochroptera: "ochroptera",
    particeps: "particeps",
    subochrea: "subochrea",
    tarsalis: "tarsalis",
  },
  Deinocerites: {
    cancer: "cancer",
    mathesoni: "mathesoni",
    pseudes: "pseudes",
  },
  Eretmapodites: {
    adami: "adami",
    angolensis: "angolensis",
    argyrurus: "argyrurus",
    brenguesi: "brenguesi",
    brottesi: "brottesi",
    caillardi: "caillardi",
    chrysogaster: "chrysogaster",
    corbeti: "corbeti",
    dracaenae: "dracaenae",
    dundo: "dundo",
    eouzani: "eouzani",
    ferrarai: "ferrarai",
    forcipulatus: "forcipulatus",
    germaini: "germaini",
    gilletti: "gilletti",
    grahami: "grahami",
    grenieri: "grenieri",
    haddowi: "haddowi",
    hamoni: "hamoni",
    harperi: "harperi",
    hightoni: "hightoni",
    inornatus: "inornatus",
    intermedius: "intermedius",
    jani: "jani",
    lacani: "lacani",
    leucopous: "leucopous",
    mahaffyi: "mahaffyi",
    marcelleae: "marcelleae",
    mattinglyi: "mattinglyi",
    melanopous: "melanopous",
    mortiauxi: "mortiauxi",
    oedipodeios: "oedipodeios",
    parvipluma: "parvipluma",
    pauliani: "pauliani",
    penicillatus: "penicillatus",
    plioleucus: "plioleucus",
    productus: "productus",
    quinquevittatus: "quinquevittatus",
    ravissei: "ravissei",
    rickenbachi: "rickenbachi",
    salauni: "salauni",
    semisimplicipes: "semisimplicipes",
    silvestris: "silvestris",
    subsimplicipes: "subsimplicipes",
    tendeiroi: "tendeiroi",
    tonsus: "tonsus",
    vansomereni: "vansomereni",
    wansoni: "wansoni",
  },
  Ficalbia: {
    circumtestacea: "circumtestacea",
    malfeyti: "malfeyti",
    nigra: "nigra",
    uniformis: "uniformis",
  },
  Haemagogus: {
    equinus: "equinus",
  },
  Hodgesia: {
    cyptopus: "cyptopus",
    nigeriae: "nigeriae",
    psectropus: "psectropus",
    sanguinae: "sanguinae",
  },
  Lutzia: {
    tigripes: "tigripes",
    vorax: "vorax",
  },
  Malaya: {
    farquharsoni: "farquharsoni",
    fraseri: "fraseri",
    marceli: "marceli",
    moucheti: "moucheti",
    taeniarostris: "taeniarostris",
    trichorostris: "trichorostris",
  },
  Mansonia: {
    africana: "africana",
    dyari: "dyari",
    perturbans: "perturbans",
    titillans: "titillans",
    uniformis: "uniformis",
  },
  Mimomyia: {
    femorata: "femorata",
    flavopicta: "flavopicta",
    hispida: "hispida",
    lacustris: "lacustris",
    mediolineata: "mediolineata",
    Mimomyiayiaformis: "Mimomyiayiaformis",
    pallida: "pallida",
    parenti: "parenti",
    perplexens: "perplexens",
    plumosa: "plumosa",
    splendens: "splendens",
    xanthozona: "xanthozona",
  },
  Orthopodomyia: {
    alba: "alba",
    aureoantennata: "aureoantennata",
    kummi: "kummi",
    nkolbissonensis: "nkolbissonensis",
    ototomoensis: "ototomoensis",
    pulcripalpis: "pulcripalpis",
    signifera: "signifera",
  },
  Psorophora: {
    ciliata: "ciliata",
    columbiae: "columbiae",
    cyanescens: "cyanescens",
    discolor: "discolor",
    ferox: "ferox",
    horrida: "horrida",
    howardii: "howardii",
    johnstonii: "johnstonii",
    longipalpus: "longipalpus",
    mathesoni: "mathesoni",
    mexicana: "mexicana",
    pygmaea: "pygmaea",
    signipennis: "signipennis",
    varipes: "varipes",
  },
  Sabethes: {
    cyaneus: "cyaneus",
  },
  Toxorhynchites: {
    aeneus: "aeneus",
    angolensis: "angolensis",
    barbipes: "barbipes",
    brevipalpis: "brevipalpis",
    camaronis: "camaronis",
    dundo: "dundo",
    erythrurus: "erythrurus",
    evansae: "evansae",
    helenae: "helenae",
    kaimosi: "kaimosi",
    lutescens: "lutescens",
    moctezuma: "moctezuma",
    nairobiensis: "nairobiensis",
    nigeriensis: "nigeriensis",
    phytophagus: "phytophagus",
    rickenbachi: "rickenbachi",
    rodhaini: "rodhaini",
    rutilus: "rutilus",
    ruwenzori: "ruwenzori",
    viridibasis: "viridibasis",
    wolfsi: "wolfsi",
    zairensis: "zairensis",
  },
  Tripteroides: {
    bambusa: "bambusa",
  },
  Uranotaenia: {
    alba: "alba",
    alboabdominalis: "alboabdominalis",
    andreae: "andreae",
    angolensis: "angolensis",
    anhydor: "anhydor",
    annulata: "annulata",
    apicotaeniata: "apicotaeniata",
    balfouri: "balfouri",
    benoiti: "benoiti",
    bilineata: "bilineata",
    bimaculata: "bimaculata",
    caeruleocephala: "caeruleocephala",
    caliginosa: "caliginosa",
    cavernicola: "cavernicola",
    chorleyi: "chorleyi",
    connali: "connali",
    devemyi: "devemyi",
    fraseri: "fraseri",
    fusca: "fusca",
    garnhami: "garnhami",
    hebrardi: "hebrardi",
    henrardi: "henrardi",
    henriquei: "henriquei",
    hopkinsi: "hopkinsi",
    lowii: "lowii",
    lucyae: "lucyae",
    lunda: "lunda",
    machadoi: "machadoi",
    mashonaensis: "mashonaensis",
    mashonanensis: "mashonanensis",
    mayeri: "mayeri",
    montana: "montana",
    musarum: "musarum",
    nigripes: "nigripes",
    nigromaculata: "nigromaculata",
    nivipous: "nivipous",
    novobscura: "novobscura",
    ornata: "ornata",
    ototomo: "ototomo",
    pallidocephala: "pallidocephala",
    palmeirimi: "palmeirimi",
    philonuxia: "philonuxia",
    principensis: "principensis",
    pseudohenrardi: "pseudohenrardi",
    ramosa: "ramosa",
    rickenbachi: "rickenbachi",
    sapphirina: "sapphirina",
    shillitonis: "shillitonis",
    signata: "signata",
    syntheta: "syntheta",
    tanzaniae: "tanzaniae",
    ugandae: "ugandae",
    unguiculata: "unguiculata",
    yovani: "yovani",
  },
  Wyeomyia: {
    mitchellii: "mitchellii",
    smithii: "smithii",
    vanduzeei: "vanduzeei",
  },
};

// reshape then to be easier to use
export const SpeciesList = Object.entries(Species).reduce(
  (acc, [genus, species]) => {
    acc.push({
      genus,
      species: Object.entries(species).map(([speciesName]) => speciesName),
    });
    return acc;
  },
  [] as { genus: string; species: string[] }[],
);

/**
 * Bycatch verdicts, in the exact spelling `contributed_species` carries.
 *
 * A specimen that is not a mosquito is still worth naming, so these say *which* bycatch it
 * is. The category is not repeated in the name - the dropdown files them all under a
 * "Bycatch" heading - so nothing about the label itself says it is bycatch. What makes it
 * bycatch is this list: the backend enumerates the same one in
 * scout-web-backend/src/utils/speciesLabels.ts and maps every entry to the bycatch
 * category, which takes the row out of the mosquito counts, the way the bare "Bycatch"
 * option used to and "Other/Unknown Bycatch" now does.
 *
 * Keep the two in step. A label only this side knows about would be stored as a mosquito.
 *
 * Ordered by the taxonomic grouping the entomologists gave rather than alphabetically, and
 * the dropdown presents them in that order.
 */
export const BYCATCH_LABELS = [
  "Other/Unknown Bycatch",
  "Crane Flies (Tipulomorpha)",
  "Phantom and Fold-Winged Crane Flies (Ptychopteridae)",
  "Primitive Crane Flies",
  "Chironomids",
  "Biting Midges",
  "Phantom Midges",
  "Miscellaneous Midges",
  "Fungus Gnats 1",
  "Fungus Gnats 2",
  "Wood gnats",
  "Flathead Mayfly",
  "Dance Flies",
  "Minute Black Scavenger Flies, March Flies, Aximyiidae, and Canthyloscelidae",
  "Gall Midges",
  "Black Flies",
  "Moth Flies",
  "Sand Flies",
  "Soldier Flies",
  "Horse and Deer Flies (Tabanidae)",
  "Hover Flies",
  "Muscid-Like Flies",
  "Bot Flies",
  "Other Flies and Acalyptratae Superfamilies",
  "Bristletails, Silverfish, Earwigs, Stoneflies, Rock Crawlers, and Thrips",
  "Mayflies",
  "Dragonflies and Damselfies",
  "Grasshoppers, Crickets, and Katydids",
  "Walkingsticks",
  "Mantids",
  "Cockroaches and Termites",
  "True Bugs, Cicadas, Hoppers, Aphids, and Allies",
  "Beetles",
  "Hymenoptera",
  "Lepidoptera",
  "Fleas",
];

/** A heading in the species dropdown and the labels filed under it. */
export interface SpeciesOptionGroup {
  /** The genus, for a taxon; the category otherwise. */
  category: string;
  /**
   * The labels themselves, already in the exact form contributed_species carries, so the
   * option's text is its stored value. A taxon keeps its genus - "Aedes albopictus", not
   * the bare epithet - because the genus is part of a binomial name. "Bycatch" is not part
   * of the name of a crane fly, so those read as just "Crane Flies (Tipulomorpha)" and
   * lean on the heading instead.
   */
  labels: string[];
}

/**
 * Every value the species dropdown offers, grouped by the category it belongs to.
 *
 * The genera come first and in `Species` order, then the three answers that are not taxa:
 * the named bycatch verdicts, debris, and "Unknown" - which is a species answer rather than
 * a category, and so leaves the specimen counting as before.
 */
export const SPECIES_OPTION_GROUPS: SpeciesOptionGroup[] = [
  ...SpeciesList.map(({ genus, species }) => ({
    category: genus,
    labels: species.map((speciesName) => `${genus} ${speciesName}`),
  })),
  { category: "Bycatch", labels: BYCATCH_LABELS },
  { category: "Debris", labels: ["Debris"] },
  { category: "Unknown", labels: ["Unknown"] },
];

export const MOSQUITO_GENUS_MAP: Record<string, string> = {
  Aedes: "Ae.",
  Culex: "Cx.",
  Anopheles: "An.",
  Culiseta: "Cs.",
  Psorophora: "Ps.",
  Coquillettidia: "Cq.",
  Mansonia: "Ma.",
  Toxorhynchites: "Tx.",
  Uranotaenia: "Ur.",
  Wyeomyia: "Wy.",
  Armigeres: "Ar.",
  Haemagogus: "Hg.",
  Orthopodomyia: "Or.",
  Deinocerites: "De.",
  Heizmannia: "Hz.",
  Eretmapodites: "Er.",
  Sabethes: "Sa.",
  Topomyia: "To.",
  Tripteroides: "Tp.",
  Ficalbia: "Ff.",
};
export const ALERT_TITLES = [
  { label: "Connection Restored", value: "connection_restored" },
  { label: "Connection Unstable", value: "connection_unstable" },
  { label: "Delayed Data", value: "delayed_data_transmission" },
  { label: "Device Failed to Start", value: "boot_failure" },
  { label: "Device is overheating.", value: "device_overheating" },
  { label: "Device Offline", value: "device_offline" },
  { label: "Device Online", value: "device_online" },
  { label: "Device Reconnected", value: "device_reconnected" },
  { label: "Firmware Update Complete", value: "firmware_update_successful" },
  { label: "Firmware Update Failed", value: "firmware_update_failure" },
  { label: "Firmware Update In Progress", value: "firmware_update_started" },
  { label: "Hardware Failed", value: "component_failure" },
  { label: "Image Capture Failed", value: "component_failure_camera" },
  { label: "Image Not Received", value: "missed_captured_detected" },
  { label: "Imaging Issue Detected", value: "imaging_system" },
  { label: "Invasive Mosquito Detected", value: "invasive_species_detected" },
  { label: "Mesh Rotation Failed", value: "component_failure_mesh" },
  { label: "Mosquito Detected", value: "detection_created" },
  { label: "Notification Failure", value: "notification_delivery_failure" },
  {
    label: "Scheduled service or inspection due",
    value: "maintenance_required",
  },
  { label: "Trap Disconnected", value: "trap_disconnected" },
  { label: "Unknown Error", value: "unknown_error" },
] as const;

export const TagColorMap: { [key: string]: string } = {
  Update: "magenta",
  Capture: "cyan",
  Motor: "green",
  Detection: "blue",
  Other: "volcano",
};
